// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-ergebnis-tsx": () => import("./../../../src/pages/ergebnis.tsx" /* webpackChunkName: "component---src-pages-ergebnis-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-print-tsx": () => import("./../../../src/pages/print.tsx" /* webpackChunkName: "component---src-pages-print-tsx" */)
}

